/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discount_Type_Form_Discount_CodeInputs */

const en_admin_discount_type_form_discount_code = /** @type {(inputs: Admin_Discount_Type_Form_Discount_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount Code`)
};

const de_admin_discount_type_form_discount_code = /** @type {(inputs: Admin_Discount_Type_Form_Discount_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rabattcode`)
};

const es_admin_discount_type_form_discount_code = /** @type {(inputs: Admin_Discount_Type_Form_Discount_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de descuento`)
};

const fr_admin_discount_type_form_discount_code = /** @type {(inputs: Admin_Discount_Type_Form_Discount_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code de réduction`)
};

const nl_admin_discount_type_form_discount_code = /** @type {(inputs: Admin_Discount_Type_Form_Discount_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kortingscode`)
};

/** @type {(inputs: Admin_Discount_Type_Form_Discount_CodeInputs) => LocalizedString} */
const it_admin_discount_type_form_discount_code = en_admin_discount_type_form_discount_code;

/** @type {(inputs: Admin_Discount_Type_Form_Discount_CodeInputs) => LocalizedString} */
const pt_br2_admin_discount_type_form_discount_code = en_admin_discount_type_form_discount_code;

/** @type {(inputs: Admin_Discount_Type_Form_Discount_CodeInputs) => LocalizedString} */
const pl_admin_discount_type_form_discount_code = en_admin_discount_type_form_discount_code;

/** @type {(inputs: Admin_Discount_Type_Form_Discount_CodeInputs) => LocalizedString} */
const hu_admin_discount_type_form_discount_code = en_admin_discount_type_form_discount_code;

/** @type {(inputs: Admin_Discount_Type_Form_Discount_CodeInputs) => LocalizedString} */
const ro_admin_discount_type_form_discount_code = en_admin_discount_type_form_discount_code;

/**
* | output |
* | --- |
* | "Discount Code" |
*
* @param {Admin_Discount_Type_Form_Discount_CodeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discount_type_form_discount_code = /** @type {((inputs?: Admin_Discount_Type_Form_Discount_CodeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discount_Type_Form_Discount_CodeInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discount_type_form_discount_code(inputs)
	if (locale === "de") return de_admin_discount_type_form_discount_code(inputs)
	if (locale === "es") return es_admin_discount_type_form_discount_code(inputs)
	if (locale === "fr") return fr_admin_discount_type_form_discount_code(inputs)
	if (locale === "nl") return nl_admin_discount_type_form_discount_code(inputs)
	if (locale === "it") return it_admin_discount_type_form_discount_code(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discount_type_form_discount_code(inputs)
	if (locale === "pl") return pl_admin_discount_type_form_discount_code(inputs)
	if (locale === "hu") return hu_admin_discount_type_form_discount_code(inputs)
	return ro_admin_discount_type_form_discount_code(inputs)
});
export { admin_discount_type_form_discount_code as "admin.discount_type_form.discount_code" }